import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import client from "../api/client";
import "./InventoryHistory.css";

const HISTORY_ENDPOINT = "/inventory-history";

const normalizeHistoryData = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.history)) return data.history;
  if (Array.isArray(data?.data)) return data.data;
  return [];
};

export default function InventoryHistory() {
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchHistory = async () => {
    try {
      console.log("Fetching inventory history from:", HISTORY_ENDPOINT);
      const res = await client.get(HISTORY_ENDPOINT);
      console.log("Inventory history response:", res.data);
      const safeHistory = normalizeHistoryData(res.data);
      console.log("History array length:", safeHistory.length);

      if (safeHistory.length > 0) {
        console.log("Sample history record:", safeHistory[0]);
      }

      setHistory(safeHistory);
    } catch (err) {
      console.error("Inventory history error:", err);
      console.error("History error details:", err?.response?.data);
      console.log("NOTE: Backend API endpoint doesn't exist yet - showing placeholder data");
      setHistory([
        {
          inventory_id: 1,
          product_name: "Sample Product",
          category: "Sample Category",
          total_in: 10,
          total_out: 0,
          balance: 10,
          last_source: "Purchase",
          last_updated: new Date().toISOString(),
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  return (
    <div className="page-container inventory-history-page">
      <div className="inventory-history-shell">
        <div className="inventory-history-hero">
          <div className="history-header">
            <div className="history-title-group">
              <button
                type="button"
                className="inventory-history-back-btn"
                onClick={() => navigate("/inventory")}
              >
                <span className="back-btn-icon" aria-hidden="true">{"\u2190"}</span>
                <span>Inventory</span>
              </button>
              <div>
                <h2>Inventory History</h2>
                <div className="history-subtitle">
                  Track inventory in/out movements and current balance.
                </div>
              </div>
            </div>
            <div className="history-status-note">Backend API endpoint pending</div>
          </div>
        </div>

        <div className="inventory-history-table-card">
          <div className="inventory-history-table-wrap">
            <table className="inventory-table inventory-history-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Item</th>
                  <th>IN</th>
                  <th>OUT</th>
                  <th>Balance</th>
                  <th>Source</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="7" className="empty-row">
                      Loading history...
                    </td>
                  </tr>
                )}

                {!loading &&
                  Array.isArray(history) && history.map((h, index) => (
                    <tr key={`${h.inventory_id}-${h.last_updated || index}`}>
                      <td>
                        {h.last_updated
                          ? new Date(h.last_updated).toLocaleString()
                          : "-"}
                      </td>
                      <td>
                        <strong>{h.product_name}</strong>
                        <div className="history-item-category">{h.category}</div>
                      </td>
                      <td className="qty-add">{h.total_in ? `+${h.total_in}` : "-"}</td>
                      <td className="qty-out">{h.total_out ? `-${h.total_out}` : "-"}</td>
                      <td className="qty-after">{h.balance}</td>
                      <td>{h.last_source || "-"}</td>
                      <td className="history-actions-cell">
                        <button
                          className="view-btn"
                          onClick={() =>
                            navigate(`/inventory/history/${h.inventory_id}`, {
                              state: { from: "/inventory/history" },
                            })
                          }
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}

                {!loading && history.length === 0 && (
                  <tr>
                    <td colSpan="7" className="empty-row">
                      No inventory history found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
